import React, { useRef, useEffect, useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import config from "../config";
import useTranslation from './useTranslation';
import MaterialIcon from './MaterialIcon';
import { NavigationHistoryContext } from '../App';
import '../css/footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathname = location.pathname;
  const footerRef = useRef(null);
  const { getActiveMenu } = useContext(NavigationHistoryContext);
  
  // Ottieni il menu attivo dalla logica nell'App.js
  const activeMenu = getActiveMenu();
  
  // Effetto per centrare l'elemento attivo quando la rotta cambia
  useEffect(() => {
    if (footerRef.current) {
      const activeLink = footerRef.current.querySelector('.active');
      if (activeLink) {
        const containerWidth = footerRef.current.offsetWidth;
        const activeLinkRect = activeLink.getBoundingClientRect();
        const containerRect = footerRef.current.getBoundingClientRect();
        
        // Calcola lo scroll necessario per centrare l'elemento
        const scrollLeft = activeLink.offsetLeft - containerWidth / 2 + activeLinkRect.width / 2;
        
        // Applica lo scroll con animazione
        footerRef.current.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
      }
    }
  }, [pathname, activeMenu]);

  // Funzione per determinare se un link è attivo
  const isLinkActive = (linkPath) => {
    return activeMenu === linkPath;
  };
  
  return (
    <footer 
      className="fixed-bottom"
      style={{
        height: 'var(--height-footer)',
        backgroundColor: 'var(--color-background-primary)',
        borderTop: 'var(--border-25)',
        zIndex: 'var(--z-footer)'
      }}
    >
      <div 
        ref={footerRef} 
        className="footer-nav-container"
      >
        <NavLink
          to="/home"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/home') ? 'active' : ''}`}
        >
          <MaterialIcon name="home" isActive={isLinkActive('/home')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1" 
             style={{ 
               color: isLinkActive('/home') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuHome')}
          </p>
        </NavLink>
        
        {config.components.wall && (
        <NavLink
          to="/wall"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/wall') ? 'active' : ''}`}
        >
          <MaterialIcon name="dashboard" isActive={isLinkActive('/wall')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1"
             style={{ 
               color: isLinkActive('/wall') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuWall')}
          </p>
        </NavLink>
        )}
   
        {config.components.map && (
        <NavLink
          to="/maplist"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/maplist') ? 'active' : ''}`}
        >
          <MaterialIcon name="explore" isActive={isLinkActive('/maplist')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1"
             style={{ 
               color: isLinkActive('/maplist') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuMappa')}
          </p>
        </NavLink>
        )}
   
        {config.components.routes && (
        <NavLink
          to="/routeslist"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/routeslist') ? 'active' : ''}`}
        >
          <MaterialIcon name="signpost" isActive={isLinkActive('/routeslist')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1"
             style={{ 
               color: isLinkActive('/routeslist') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuPercorsi')}
          </p>
        </NavLink>
        )}
        
        {config.components.extra && (
        <NavLink
          to="/extra"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/extra') ? 'active' : ''}`}
        >
          <MaterialIcon name="info" isActive={isLinkActive('/extra')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1"
             style={{ 
               color: isLinkActive('/extra') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuInfo')}
          </p>
        </NavLink>
        )}
        
        {config.components.qrcode && (
        <NavLink
          to="/qr-scanner"
          className={`footer-link d-flex flex-column align-items-center ${isLinkActive('/qr-scanner') ? 'active' : ''}`}
        >
          <MaterialIcon name="qr_code_scanner" isActive={isLinkActive('/qr-scanner')} className="footer-icon" />
          <p className="footer-text mb-0 small mt-1"
             style={{ 
               color: isLinkActive('/qr-scanner') ? 'var(--color-text-primary)' : 'var(--color-text-muted)',
               fontSize: 'var(--font-size-sm)',
               fontFamily: 'var(--font-primary)'
             }}>
            {t('menuQrCode')}
          </p>
        </NavLink>
        )}
      </div>
    </footer>
  );
};

export default Footer;